import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { SERVICE_DETAILS, EVENTS, IMAGES } from "../data/content";

export default function Services() {
  return (
    <div data-testid="services-page" className="bg-bone">
      <section className="pt-28 lg:pt-36 pb-16 bg-charcoal">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
          <div className="eyebrow text-gold mb-3">Our Services</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-semibold text-white text-balance">
            Elevated island flavor, tailored to your occasion.
          </h1>
          <p className="mt-5 text-platinum text-lg max-w-2xl">
            From drop-off catering to intimate private chef experiences, every service is customized around your guests, your vision, and your menu.
          </p>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
          {SERVICE_DETAILS.map((s, i) => (
            <div key={s.key} data-testid={`service-detail-${s.key}`}
              className={`grid gap-8 lg:gap-14 lg:grid-cols-2 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
              <div className="lg:[direction:ltr] overflow-hidden rounded-3xl aspect-[4/3]">
                <img src={s.image} alt={s.title} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="lg:[direction:ltr]">
                <div className="eyebrow text-crimson mb-2">Service {String(i + 1).padStart(2, "0")}</div>
                <h2 className="text-3xl sm:text-4xl font-serif font-semibold text-charcoal">{s.title}</h2>
                <p className="mt-3 text-slate-600 text-lg">{s.intro}</p>
                <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                  {s.list.map((item) => (
                    <li key={item} className="flex items-center gap-2 text-slate-700">
                      <span className="w-5 h-5 rounded-full bg-emerald/10 flex items-center justify-center shrink-0">
                        <Check className="w-3 h-3 text-emerald" />
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" data-testid={`service-cta-${s.key}`}
                  className="mt-7 inline-flex items-center gap-2 text-charcoal font-semibold border-b-2 border-gold pb-1 hover:gap-3 transition-all">
                  Request a Quote <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* EVENTS WE SERVE */}
      <section className="relative py-20 lg:py-28 overflow-hidden">
        <img src={IMAGES.servicesFeatured} alt="Jamaican brown stew oxtail with rice and peas and plantains" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-charcoal/88" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading light center eyebrow="Events We Serve" title="Every Occasion Deserves Platinum" />
          <div className="mt-12 flex flex-wrap justify-center gap-3">
            {EVENTS.map((e) => (
              <span key={e} data-testid={`event-chip-${e.toLowerCase().replace(/\s+/g,'-')}`}
                className="rounded-full border border-gold/40 bg-white/5 px-5 py-2.5 text-platinum hover:bg-gold hover:text-charcoal transition-colors">
                {e}
              </span>
            ))}
          </div>
          <div className="mt-12 text-center">
            <Link to="/contact" data-testid="services-plan-event-cta"
              className="inline-flex items-center gap-2 rounded-full bg-gold px-7 py-4 font-semibold text-charcoal hover:bg-gold-bright transition-transform hover:scale-[1.03]">
              Plan Your Event <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
